import { useContext } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
} from "@mui/material";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import GroupsRoundedIcon from "@mui/icons-material/GroupsRounded";
import SwapHorizRoundedIcon from "@mui/icons-material/SwapHorizRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import { useLocation, useNavigate } from "react-router-dom";
import { LoginContext } from "../Components/Login/LoginContext";

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [auth] = useContext(LoginContext);

  const isCompetitions =
    location.pathname.startsWith("/competition") ||
    location.pathname.startsWith("/season") ||
    location.pathname.startsWith("/match");

  const isTeams =
    location.pathname.startsWith("/team") ||
    location.pathname.startsWith("/player") ||
    location.pathname.startsWith("/manager") ||
    location.pathname.startsWith("/appearance");

  const getValue = () => {
    if (location.pathname === "/") return "home";
    if (isCompetitions) return "competitions";
    if (isTeams) return "teams";
    if (location.pathname.startsWith("/transferRequest")) return "transfers";
    if (location.pathname.startsWith("/profile")) return "profile";
    if (location.pathname.startsWith("/dashboard")) return "dashboard";
    return false;
  };

  return (
    <Paper
      sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1100 }}
      elevation={3}
    >
      <BottomNavigation value={getValue()} showLabels>
        <BottomNavigationAction
          label="Home"
          value="home"
          icon={<HomeRoundedIcon />}
          onClick={() => navigate("/")}
        />
        <BottomNavigationAction
          label="Competitions"
          value="competitions"
          icon={<EmojiEventsRoundedIcon />}
          onClick={() => navigate("/competitions")}
        />
        <BottomNavigationAction
          label="Teams"
          value="teams"
          icon={<GroupsRoundedIcon />}
          onClick={() => navigate("/teams")}
        />
        <BottomNavigationAction
          label="Transfers"
          value="transfers"
          icon={<SwapHorizRoundedIcon />}
          onClick={() => navigate("/transferRequests")}
        />
        {auth.loggedIn && (
          <BottomNavigationAction
            label="Profile"
            value="profile"
            icon={<AccountCircleRoundedIcon />}
            onClick={() => navigate("/profile")}
          />
        )}
        {auth.loggedIn && (
          <BottomNavigationAction
            label="Dashboard"
            value="dashboard"
            icon={<DashboardRoundedIcon />}
            onClick={() => navigate("/dashboard")}
          />
        )}
      </BottomNavigation>
    </Paper>
  );
};

export default BottomNav;
